import { render, staticRenderFns } from "./SetupRoot.vue?vue&type=template&id=3626eb29"
import script from "./SetupRoot.vue?vue&type=script&lang=ts"
export * from "./SetupRoot.vue?vue&type=script&lang=ts"
import style0 from "./SetupRoot.vue?vue&type=style&index=0&id=3626eb29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports